import { reduxKey } from './constants';

export enum WriterError {
  GifCountExceeded = 'gif count exceeded',
  EmoteCountExceeded = 'emote count exceeded',
  ImageCountExceeded = 'image count exceeded',
  MentionCountExceeded = 'mention count exceeded',
  ContentTooLong = 'content too long',
  Unspecified = 'error unspecified',
  Spam = 'System thinks this is spam.',
}

export enum WriterPopupType {
  JOURNAL = 'JOURNAL',
  LITERATURE = 'LITERATURE',
}

export interface WriterStoreSlice {
  deviationId?: number | null;
  isSubmitting?: boolean;
  isFeatured?: boolean;
  error?: WriterError | null;
}

export interface WriterStoreState {
  [reduxKey]?: WriterStoreSlice;
}
